/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="85.17"
        viewBox="0 0 95.58 85.17"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="m26.07 77.14 2.25 1.09-2.43 5.06a3.34 3.34 0 0 1-2.8 1.88H9.61A3.32 3.32 0 0 1 6.29 82v-4.65h2.5v4.46a.83.83 0 0 0 .73.82h13.37a.81.81 0 0 0 .69-.36l.05-.1ZM69.5 77.14l2.43 5.07a.82.82 0 0 0 .62.46h13.4a.82.82 0 0 0 .82-.72v-4.56h2.5v4.46a3.33 3.33 0 0 1-3.14 3.32H72.69a3.31 3.31 0 0 1-2.9-1.7l-.09-.18-2.44-5.06Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M61.3 35a4.62 4.62 0 1 1-4.62 4.62A4.62 4.62 0 0 1 61.3 35m-12.13 6.78h3.47a8.85 8.85 0 0 0 1 2.41l-2.46 2.47a2.164 2.164 0 0 0 3.06 3.06l2.47-2.46a8.83 8.83 0 0 0 2.41 1v3.48a2.17 2.17 0 0 0 4.34 0v-3.48a8.83 8.83 0 0 0 2.41-1l2.46 2.46a2.17 2.17 0 0 0 3.07-3.06l-2.47-2.47a8.85 8.85 0 0 0 1-2.41h3.48a2.17 2.17 0 0 0 0-4.34h-3.46a8.55 8.55 0 0 0-1-2.41l2.47-2.46a2.17 2.17 0 0 0-3.07-3.07L65.88 32a9 9 0 0 0-2.38-1v-3.52a2.17 2.17 0 0 0-4.34 0V31a8.85 8.85 0 0 0-2.41 1l-2.5-2.5a2.164 2.164 0 0 0-3.06 3.06L53.65 35a8.85 8.85 0 0 0-1 2.41h-3.48a2.17 2.17 0 0 0 0 4.34"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M16.64 17.15h-5.7a1.75 1.75 0 0 0-1.75 1.75v8.64a1.75 1.75 0 0 0 1.75 1.75h5.7a1.75 1.75 0 0 0 1.75-1.75V18.9a1.75 1.75 0 0 0-1.75-1.75Zm-.75 2.5v7.14h-4.2v-7.14ZM16.64 49.36h-5.7a1.75 1.75 0 0 0-1.75 1.75v8.63a1.75 1.75 0 0 0 1.75 1.75h5.7a1.75 1.75 0 0 0 1.75-1.75v-8.63a1.75 1.75 0 0 0-1.75-1.75Zm-.75 2.49V59h-4.2v-7.15Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M89.71 0H5.87A5.87 5.87 0 0 0 0 5.87v66.9a5.87 5.87 0 0 0 5.87 5.87h83.84a5.87 5.87 0 0 0 5.87-5.87V5.87A5.87 5.87 0 0 0 89.71 0ZM5.87 2.5h83.84a3.37 3.37 0 0 1 3.37 3.37v66.9a3.37 3.37 0 0 1-3.37 3.37H5.87a3.37 3.37 0 0 1-3.37-3.37V5.87A3.37 3.37 0 0 1 5.87 2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M13.79 26.79a1.24 1.24 0 0 1 1.24 1.12v22.7a1.25 1.25 0 0 1-2.49.12V28a1.25 1.25 0 0 1 1.25-1.21Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M82.37 9.86a3.37 3.37 0 0 1 3.35 3.22v52.3a3.39 3.39 0 0 1-3.18 3.4H15.9a3.39 3.39 0 0 1-3.4-3.21v-5.33a1.25 1.25 0 0 1 2.49-.12v5.26a.88.88 0 0 0 .76.9h66.57a.87.87 0 0 0 .85-.79V13.26a.91.91 0 0 0-.76-.9H15.9a.87.87 0 0 0-.85.79v5.25a1.25 1.25 0 0 1-2.49.13v-5.27a3.39 3.39 0 0 1 3.18-3.4h66.65Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'HomeSafeLockedIcon';

export default Icon;
